import { render } from "./MonitorInstructionTitle.vue?vue&type=template&id=a65ecd20&scoped=true"
import script from "./MonitorInstructionTitle.vue?vue&type=script&lang=js"
export * from "./MonitorInstructionTitle.vue?vue&type=script&lang=js"

import "./MonitorInstructionTitle.vue?vue&type=style&index=0&id=a65ecd20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65ecd20"]])

export default __exports__